export const api = {
  aws: {
    url: '/wp-json/playmotivcloud/core/v4/aws?path=',
    options: {
      headers: {          
        'Authorization': 'Bearer ' + (window.playmotiv.user.token || '')
      }
    }
  },
  core: {
    url: '/wp-json/playmotivcloud/core/v4',
    options: {
      headers: {          
        'Authorization': 'Bearer ' + window.playmotiv.user.token
      }
    }
  }
}